/* eslint-disable */
// @ts-nocheck
/* eslint-disable radix */
 
 
 
/* eslint-disable prefer-template */
/* eslint-disable react/self-closing-comp */
 
/* eslint-disable padding-line-between-statements, import/order */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/rules-of-hooks, react-hooks/exhaustive-deps */
 
/* eslint-disable react/jsx-newline */
/* eslint-disable react/button-has-type */
 
 
/* eslint-disable no-nested-ternary */

import axios from "axios";
import React, { Fragment, useEffect, useRef, useState } from 'react'
import { Suspense } from 'react'
import { Link, NavLink, useHistory } from "react-router-dom";
import { ToastContainer, toast } from 'react-toastify';
import { useTranslation } from 'react-i18next'
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import SearchIcon from '@mui/icons-material/Search';
import ClearIcon from '@mui/icons-material/Clear';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import UnfoldMoreIcon from '@mui/icons-material/UnfoldMore';
import {
  CircularProgress,
} from '@material-ui/core';
import {
  createStyles,
  makeStyles,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from '@material-ui/core';
import { basicButtonStyles, tableRowStyles } from 'app/shared/styles';
import { TextCell } from 'app/components/shared/table';
import { useIntl } from 'react-intl';
import { useTypedSelector } from 'helpers';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { hasWriteAccessToMasterConfigSubSystem, hasWriteAccessToFaresSubSystem, hasWriteAccessToOperationsSubSystem } from 'selectors';
import { Modal } from "react-bootstrap";
import { FilterEntity } from "./filter-Entity";

const useStyles = makeStyles(() =>
  createStyles({
    table: { minWidth: 750, overflow: 'scroll', whiteSpace: 'nowrap' },
    addButton: { ...basicButtonStyles },
    row: { ...tableRowStyles },
  })
);

/**
 * EntityTable - Reusable dynamic table component
 * 
 * @param {Object} props
 * @param {string} props.pageTitle - Translation key for page title
 * @param {Object} props.pageIcon - Icon component for page header
 * @param {string} props.addButtonLabel - Translation key for add button
 * @param {string} props.addPageUrl - URL to navigate for adding new entity
 * @param {string} props.viewPageUrl - URL pattern for viewing entity (use :id placeholder)
 * @param {string} props.editPageUrl - URL pattern for editing entity (use :id placeholder)
 * @param {string} props.getApiUrl - API endpoint for fetching data
 * @param {string} props.getApiMethod - HTTP method for get API ('GET' or 'POST', default: 'GET')
 * @param {Object} props.getApiPayload - Payload for POST requests (optional)
 * @param {string} props.deleteApiUrl - API endpoint for deleting entity (use :id placeholder)
 * @param {string} props.deleteApiMethod - HTTP method for delete API ('GET', 'POST', 'DELETE', default: 'DELETE')
 * @param {Function} props.buildDeletePayload - Function to build delete payload (optional)
 * @param {string} props.responseDataPath - Path to data array in response (e.g., 'data.banks', 'data.organisationBanks')
 * @param {string} props.responsePaginationPath - Path to pagination in response (default: 'data.pagination')
 * @param {Array} props.columns - Array of column configurations
 * @param {string} props.idField - Field name for entity ID (default: 'id')
 * @param {string} props.searchQueryParam - Query param name for search (e.g., 'search', 'serial_num'). If null, search is hidden
 * @param {string} props.searchPlaceholder - Translation key for search placeholder
 * @param {string} props.searchInputWidth - Width of search input (default: '240px')
 * @param {Array} props.filterFields - Array of filter field configurations (if empty, filter button is hidden)
 * @param {string} props.subsystemName - Name of subsystem for permission check (optional)
 * @param {string} props.permissionSystem - Permission system to use: 'masterConfig', 'fares', 'operations' (default: 'masterConfig')
 * @param {boolean} props.showAddButton - Whether to show add button (default: true)
 * @param {boolean} props.showActions - Whether to show actions column (default: true)
 * @param {boolean} props.showEdit - Whether to show edit action (default: true)
 * @param {boolean} props.showDelete - Whether to show delete action (default: true)
 * @param {string} props.deleteConfirmationMessage - Translation key for delete confirmation (optional)
 * @param {Function} props.customRowRender - Custom function to render table rows (optional)
 * 
 * Column Configuration:
 * {
 *   field: string,              // Field name in data
 *   headerKey: string,          // Translation key for header
 *   align: string,              // Alignment ('left', 'center', 'right')
 *   render: Function            // Custom render function (optional): (value, row) => ReactNode
 *   sortable: boolean,          // If true, clicking the header toggles sort on this column
 *   sortField: string,          // Backend sort param value (e.g. 'db.created_at'). Required when sortable=true
 * }
 * 
 * Filter Field Configuration:
 * {
 *   name: string,               // Query param name
 *   labelKey: string,           // Translation key for label
 *   type: string                // Field type ('text', 'number', etc.)
 * }
 */
const EntityTable: React.FC = ({
  pageTitle,
  pageIcon: PageIcon,
  addButtonLabel,
  addPageUrl,
  viewPageUrl,
  editPageUrl,
  getApiUrl,
  getApiMethod = 'GET',
  getApiPayload = {},
  deleteApiUrl,
  deleteApiMethod = 'DELETE',
  deleteBody,
  buildDeletePayload,
  responseDataPath = 'data.data',
  responsePaginationPath = 'data.pagination',
  columns = [],
  idField = 'id',
  searchQueryParam = null,
  searchPlaceholder = 'Search',
  searchInputWidth = '240px',
  filterFields = [],
  subsystemName,
  permissionSystem = 'masterConfig',
  showAddButton = true,
  showActions = true,
  showEdit = true,
  showDelete = true,
  deleteConfirmationMessage,
  customRowRender,
  messageTransformer,
}) => {
  const intl = useIntl();
  const classes = useStyles();
  const history = useHistory();
  const currentLanguageCode = localStorage.getItem("EASY_MOBILITY_LANGUAGE") || 'en-us';

  const [isLoading, setIsLoading] = useState(true);
  const [mainApiResponseData, setMainApiResponseData] = useState<any[]>([]);
  const [page, setPage] = useState<any>(1);
  const [limit, setLimit] = useState<any>(10);
  const [pageCount, setPageCount] = useState<any>(0);
  const [dataCountNumber, setDataCountNumber] = useState(null);
  const [searchParams, setSearchParams] = useState<Record<string, string>>({});
  const [searchValue, setSearchValue] = useState<string>('');
  const [isSearchClicked, setIsSearchClicked] = useState<boolean>(false);
  const [sortBy, setSortBy] = useState<string>('');
  const [sortOrder, setSortOrder] = useState<string>('DESC');

  let loggedInUserAccessTokenClientUid: any = '';

  const authData = localStorage.getItem("authData");

  if (authData !== null) {
    const parsedAuthData = JSON.parse(authData);
    loggedInUserAccessTokenClientUid = parsedAuthData.userToken;
  }

  // Check write access if subsystem is provided
  const hasWriteAccess = subsystemName
    ? (() => {
        switch (permissionSystem) {
          case 'fares':
            return useTypedSelector(state => hasWriteAccessToFaresSubSystem(state, subsystemName));
          case 'operations':
            return useTypedSelector(state => hasWriteAccessToOperationsSubSystem(state, subsystemName));
          case 'masterConfig':
          default:
            return useTypedSelector(state => hasWriteAccessToMasterConfigSubSystem(state, subsystemName));
        }
      })()
    : true;

  // Extract data from nested path
  const getNestedValue = (obj: any, path: string) => {
    return path.split('.').reduce((acc, part) => acc && acc[part], obj);
  };

  useEffect(() => {
    const makeRequest = () => {
      setIsLoading(true);

      // Build query params
      const queryParams = {
        pageSize: limit,
        page,
        ...searchParams,
        ...(sortBy ? { sortBy, sortOrder } : {}),
      };

      const config = {
        headers: {
          'Content-Type': 'application/json',
          'access-token': loggedInUserAccessTokenClientUid['access-token'],
          'uid': loggedInUserAccessTokenClientUid.uid,
          'client': loggedInUserAccessTokenClientUid.client
        },
        params: getApiMethod.toUpperCase() === 'GET' ? queryParams : { pageSize: limit, page },
      };

      let finalGetUrl = getApiUrl;
      if (!finalGetUrl.startsWith('http')) {
        finalGetUrl = `${process.env.REACT_APP_ABT_ALL_APIS_BASE_URL}${finalGetUrl}`;
      }

      const apiCall = getApiMethod.toUpperCase() === 'POST'
        ? axios.post(finalGetUrl, { ...getApiPayload, ...searchParams }, config)
        : axios.get(finalGetUrl, config);

      apiCall
        .then((res) => {
          const data = getNestedValue(res, responseDataPath);
          const pagination = getNestedValue(res, responsePaginationPath);

          setMainApiResponseData(Array.isArray(data) ? data : []);
          
          if (pagination) {
            setDataCountNumber(pagination.total);
            setPageCount(pagination.totalPages);
          } else {
            // Fallback for old response format
            setDataCountNumber(res.data.data.totalCount || res.data.data.total);
            setPageCount(res.data.data.totalPages);
          }
          
          setIsLoading(false);
        })
        .catch((err) => {
          console.error("API ERROR", err);
          toast.error(`${err.message}`);
          setIsLoading(false);
        });
    };

    makeRequest();
  }, [page, limit, searchParams, sortBy, sortOrder]);

  // Handle column header click for sorting
  const handleSortColumn = (col: any) => {
    if (!col.sortable || !col.sortField) return;
    if (sortBy === col.sortField) {
      // Toggle order
      setSortOrder(prev => prev === 'DESC' ? 'ASC' : 'DESC');
    } else {
      setSortBy(col.sortField);
      setSortOrder('DESC');
    }
    setPage(1);
  };

  const handleResetSort = (e: React.MouseEvent) => {
    e.stopPropagation();
    setSortBy('');
    setSortOrder('DESC');
    setPage(1);
  };

  // Render sort icon for a column header
  const renderSortIcon = (col: any) => {
    if (!col.sortable) return null;
    const isActive = sortBy === col.sortField;
    if (!isActive) {
      return <UnfoldMoreIcon style={{ fontSize: '20px', verticalAlign: 'middle', opacity: 0.4, marginLeft: '4px', strokeWidth: 1 }} />;
    }
    return (
      <span style={{ display: 'inline-flex', alignItems: 'center' }}>
        {sortOrder === 'ASC'
          ? <ArrowUpwardIcon style={{ fontSize: '20px', verticalAlign: 'middle', color: '#1976d2', marginLeft: '4px', strokeWidth: 1.5, stroke: '#1976d2' }} />
          : <ArrowDownwardIcon style={{ fontSize: '20px', verticalAlign: 'middle', color: '#1976d2', marginLeft: '4px', strokeWidth: 1.5, stroke: '#1976d2' }} />
        }
        <ClearIcon 
          onClick={handleResetSort} 
          style={{ fontSize: '18px', color: 'black', marginLeft: '6px', cursor: 'pointer', border: '1px solid gray', borderRadius: '3px', padding: '1px' }} 
          titleAccess="Reset Sort" 
        />
      </span>
    );
  };

  const handlePrevious = () => {
    if (page > 1) setPage(page - 1);
  };

  const handleNext = () => {
    if (page < pageCount) setPage(page + 1);
  };

  const handleChangeLimit = (lim: number) => {
    setLimit(lim);
    setPage(1);
  };

  const applyFilters = (filters: Record<string, string>) => {
    const updatedParams = { ...filters };
    if (searchQueryParam && searchValue) {
      updatedParams[searchQueryParam] = searchValue;
    }
    setSearchParams(updatedParams);
    setPage(1);
  };

  const handleSearchClick = (e) => {
    e.preventDefault();
    if (searchQueryParam) {
      setSearchParams(prevParams => ({ ...prevParams, [searchQueryParam]: searchValue }));
      setPage(1);
      setIsSearchClicked(true);
    }
  };

  const handleClearSearch = () => {
    setSearchValue('');
    const updatedSearchParams = { ...searchParams };
    if (searchQueryParam) {
      delete updatedSearchParams[searchQueryParam];
    }
    setSearchParams(updatedSearchParams);
    setIsSearchClicked(false);
  };

  const handleDelete = async (row: any, event: any) => {
    event.stopPropagation();
    setIsLoading(true);

    try {
      const entityId = row[idField];
      let url = deleteApiUrl.replace(':id', entityId);
      
      if (!url.startsWith('http')) {
        url = `${process.env.REACT_APP_ABT_ALL_APIS_BASE_URL}${url}`;
      }
      
      const config = {
        headers: {
          'access-token': loggedInUserAccessTokenClientUid['access-token'],
          'uid': loggedInUserAccessTokenClientUid.uid,
          'client': loggedInUserAccessTokenClientUid.client,
        },
      };

      let response;
      const method = deleteApiMethod.toUpperCase();
      
      if (method === 'POST' || method === 'PUT' || method === 'PATCH') {
        const payload = buildDeletePayload 
          ? buildDeletePayload(row) 
          : (deleteBody || {});
        response = await axios[method.toLowerCase()](url, payload, config);
      } else {
        response = await axios.delete(url, config);
      }

      toast.success(intl.formatMessage({ id: 'DeletedSuccessfully' }) || 'Deleted successfully!', {
        position: 'top-right',
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
      });

      // Refresh data
      setSearchParams({ ...searchParams });
    } catch (error) {
      const rawMessage = error?.response?.data?.message || error.toString();
      const errorMessage = messageTransformer ? messageTransformer(rawMessage) : rawMessage;
      const isArabicMsg = /[\u0600-\u06FF]/.test(errorMessage || '');
      toast.error(`${errorMessage}`, {
        position: 'top-right',
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        style: {
          direction: isArabicMsg ? 'rtl' : 'ltr',
          textAlign: isArabicMsg ? 'right' : 'left',
          fontFamily: 'Cairo, sans-serif',
          fontWeight: 'bold',
        },
      });
    } finally {
      setIsLoading(false);
    }
  };

  const moveToEditPage = (id, event) => {
    event.stopPropagation();
    const url = editPageUrl.replace(':id', id);
    history.push(url);
  };

  const tableRowClickNavigation = (id) => {
    const url = viewPageUrl.replace(':id', id);
    history.push(url);
  };

  const startItem = (page - 1) * limit + 1;
  const endItem = Math.min(page * limit, dataCountNumber || 0);

  return (
    <div className='dev-contain-all-page-content'>
      <h2 className='header-of-subsystem-page'>
        {PageIcon && <PageIcon style={{ margin: "10px  10px 13px 10px", fontSize: "28px" }} />}
        {intl.formatMessage({ id: pageTitle })}
      </h2>

      {hasWriteAccess && showAddButton && (
        <button
          className="styleAddBtn"
          style={currentLanguageCode === "en-us" ? { right: "90px" } : { left: "90px" }}
          onClick={() => history.push(addPageUrl)}
        >
          {intl.formatMessage({ id: addButtonLabel })}
        </button>
      )}

      <div className='table-controller-sec'>
        <div style={{ display: "flex", marginTop: "0px", marginBottom: "0px" }}>
          {searchQueryParam && (
            <form
              onSubmit={handleSearchClick}
              className="input-search"
              style={currentLanguageCode !== "en-us" ? { direction: 'rtl' } : {}}
            >
              <input
                type="text"
                style={{
                  width: searchInputWidth,
                  direction: currentLanguageCode !== "en-us" ? 'rtl' : 'ltr',
                  textAlign: currentLanguageCode !== "en-us" ? 'right' : 'left',
                }}
                value={searchValue}
                onChange={(e) => setSearchValue((e.target.value).trim())}
                placeholder={intl.formatMessage({ id: searchPlaceholder })}
              />
              <button
                style={currentLanguageCode === "en-us" ? { right: "8px" } : { left: "8px" }}
                type="submit"
              >
                <SearchIcon style={{ fontSize: "22px" }} />
              </button>
            </form>
          )}

          {isSearchClicked && searchQueryParam && (
            <button
              className="cancelBtnStyle"
              style={{ marginTop: "0px", marginBottom: "15px" }}
              onClick={handleClearSearch}
            >
              <ClearIcon style={{ fontSize: "22px", padding: "0" }} />
            </button>
          )}

          {filterFields && filterFields.length > 0 && (
            <FilterEntity
              applyFilters={applyFilters}
              filterFields={filterFields}
            />
          )}
        </div>

        <div style={{ direction: "ltr" }}>
          {mainApiResponseData?.length > 0 && (
            <>
              <span style={{ margin: "10px", direction: "ltr" }}>
                {page}
                <span className='show-span'>
                  <bdi style={{ margin: "10px" }}>
                    {intl.formatMessage({ id: 'From' })}
                  </bdi>
                </span>
                {pageCount}
              </span>
              <button className='page-navigation-arrow' disabled={page === 1} onClick={handlePrevious}>
                <KeyboardArrowLeftIcon style={{ fontSize: "30px" }} />
              </button>
              <bdi>{startItem} - {endItem} {intl.formatMessage({ id: 'Of' })} {dataCountNumber}</bdi>
              <button className='page-navigation-arrow' disabled={page === pageCount} onClick={handleNext}>
                <KeyboardArrowRightIcon style={{ fontSize: "30px" }} />
              </button>

              <span style={{ margin: "10px" }}>
                <bdi>
                  <span className='show-span' style={{ margin: "10px" }}>{intl.formatMessage({ id: 'Show' })}</span>
                  <select className='show-select' onChange={(e) => handleChangeLimit(parseInt(e.target.value))}>
                    <option value="10">10</option>
                    <option value="15">15</option>
                    <option value="25">25</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                    <option value="150">150</option>
                  </select>
                </bdi>
              </span>
            </>
          )}
        </div>
      </div>

      <div className="Table-Wrapper">
        {isLoading ? (
          <div style={{ textAlign: "center", marginTop: "7px" }}>
            <CircularProgress style={{ width: "42px" }} />
          </div>
        ) : (
          <Table className={classes.table} size="small" aria-label="entity table">
            <TableHead style={{ border: "0" }}>
              <TableRow style={{ border: "0" }}>
                {columns.map((col, index) => (
                  <TableCell
                    key={index}
                    align={col.align || "center"}
                    onClick={() => handleSortColumn(col)}
                    style={col.sortable ? { cursor: 'pointer', userSelect: 'none', whiteSpace: 'nowrap' } : {}}
                  >
                    {intl.formatMessage({ id: col.headerKey })}
                    {renderSortIcon(col)}
                  </TableCell>
                ))}
                {hasWriteAccess && showActions && (
                  <TableCell align="center">
                    {intl.formatMessage({ id: 'actions' })}
                  </TableCell>
                )}
              </TableRow>
            </TableHead>
            <TableBody>
              {mainApiResponseData?.length > 0 ? (
                mainApiResponseData.map((row) => {
                  if (customRowRender) {
                    return customRowRender(row, classes, {
                      tableRowClickNavigation,
                      moveToEditPage,
                      handleDelete,
                      hasWriteAccess,
                      showEdit,
                      showDelete,
                      idField,
                      deleteConfirmationMessage,
                      currentLanguageCode,
                      intl,
                    });
                  }

                  return (
                    <TableRow
                      className={classes.row}
                      key={row[idField]}
                      onClick={() => tableRowClickNavigation(row[idField])}
                    >
                      {columns.map((col, index) => {
                        const value = row[col.field];
                        const displayValue = col.render ? col.render(value, row) : value;
                        
                        return (
                          <TableCell key={index} align={col.align || "center"}>
                            {displayValue}
                          </TableCell>
                        );
                      })}
                      
                      {hasWriteAccess && showActions && (
                        <TextCell
                          label={
                            <>
                              {showEdit && (
                                <EditIcon
                                  className="editAndDeleteIcon"
                                  onClick={(e) => moveToEditPage(row[idField], e)}
                                />
                              )}
                              {showDelete && (
                                <>
                                  <button
                                    className="delBtn editAndDeleteIcon"
                                    data-bs-toggle="modal"
                                    onClick={(e) => e.stopPropagation()}
                                    data-bs-target={"#deleteModal" + row[idField]}
                                  >
                                    <DeleteIcon />
                                  </button>
                                  <div
                                    className="modal fade"
                                    style={{ zIndex: "9999969" }}
                                    id={"deleteModal" + row[idField]}
                                    tabIndex={-1}
                                    aria-labelledby="deleteModalLabel"
                                    aria-hidden="true"
                                  >
                                    <div className="modal-dialog">
                                      <div className="modal-content">
                                        <div className="modal-header">
                                          <button
                                            type="button"
                                            className="btn-close"
                                            data-bs-dismiss="modal"
                                            aria-label="Close"
                                          ></button>
                                        </div>
                                        <div className="modal-body">
                                          <h5>
                                            {deleteConfirmationMessage
                                              ? intl.formatMessage({ id: deleteConfirmationMessage })
                                              : currentLanguageCode === "en-us"
                                              ? `Are you sure you want to delete this item?`
                                              : `هل أنت متأكد أنك تريد حذف هذا العنصر؟`}
                                          </h5>
                                        </div>
                                        <div
                                          className="modal-footer"
                                          style={{
                                            direction: currentLanguageCode === "en-us" ? "ltr" : "rtl",
                                          }}
                                        >
                                          <button
                                            type="button"
                                            onClick={(e) => e.stopPropagation()}
                                            className="btn btn-outline-dark"
                                            data-bs-dismiss="modal"
                                          >
                                            {intl.formatMessage({ id: 'Cancel' })}
                                          </button>
                                          <button
                                            type="button"
                                            className="btn btn-danger"
                                            data-bs-dismiss="modal"
                                            onClick={(e) => handleDelete(row, e)}
                                          >
                                            {intl.formatMessage({ id: 'Delete' })}
                                          </button>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </>
                              )}
                            </>
                          }
                          align="center"
                        />
                      )}
                    </TableRow>
                  );
                })
              ) : (
                <TableRow>
                  <TableCell
                    colSpan={columns.length + (hasWriteAccess && showActions ? 1 : 0)}
                    style={{ textAlign: "center", padding: "15px" }}
                  >
                    {intl.formatMessage({ id: 'NoDateAvailable' })}
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        )}
      </div>

      <ToastContainer />
    </div>
  );
};

export default EntityTable;
